"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortIcon = void 0;
const react_1 = __importDefault(require("react"));
const _1 = require(".");
function SortIcon({ direction, ...props }) {
    switch (direction) {
        case "ascending":
            return react_1.default.createElement(_1.SortUpIcon, { ...props });
        case "descending":
            return react_1.default.createElement(_1.SortDownIcon, { ...props });
        default:
            return react_1.default.createElement(_1.UnsortedIcon, { className: "unsorted-icon", ...props });
    }
}
exports.SortIcon = SortIcon;
exports.default = SortIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29ydC1pY29uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vaWNvbnMvc29ydC1pY29uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFBMEI7QUFHMUIsd0JBQXNFO0FBRXRFLFNBQWdCLFFBQVEsQ0FBQyxFQUFFLFNBQVMsRUFBRSxHQUFHLEtBQUssRUFBcUQ7SUFDakcsUUFBUSxTQUFTLEVBQUU7UUFDakIsS0FBSyxXQUFXO1lBQ2QsT0FBTyw4QkFBQyxhQUFVLE9BQUssS0FBSyxHQUFJLENBQUM7UUFDbkMsS0FBSyxZQUFZO1lBQ2YsT0FBTyw4QkFBQyxlQUFZLE9BQUssS0FBSyxHQUFJLENBQUM7UUFDckM7WUFDRSxPQUFPLDhCQUFDLGVBQVksSUFBQyxTQUFTLEVBQUMsZUFBZSxLQUFLLEtBQUssR0FBSSxDQUFDO0tBQ2hFO0FBQ0gsQ0FBQztBQVRELDRCQVNDO0FBRUQsa0JBQWUsUUFBUSxDQUFDIn0=